import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import { SensitivityTooltip } from '../SensitivityTooltip';
// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render SensitivityLabel.
 *
 * The returned state can be modified with hooks such as useSensitivityLabelStyles_unstable,
 * before being passed to renderSensitivityLabel_unstable.
 *
 * @param props - props from this instance of SensitivityLabel
 * @param ref - reference to root HTMLElement of SensitivityLabel
 */
export const useSensitivityLabel_unstable = (props, ref) => {
  const label = slot.optional(props.label, {
    elementType: 'span',
    defaultProps: {
      children: props.children
    },
    renderByDefault: true
  });
  const defaultTooltipHeading = typeof (label === null || label === void 0 ? void 0 : label.children) !== 'boolean' ? label === null || label === void 0 ? void 0 : label.children : undefined;
  return {
    components: {
      root: 'span',
      label: 'span',
      tooltip: SensitivityTooltip
    },
    root: slot.always(getIntrinsicElementProps('span', {
      ref,
      ...props
    }), {
      elementType: 'span'
    }),
    label,
    tooltip: slot.optional(props.tooltip, {
      defaultProps: {
        heading: defaultTooltipHeading,
        message: props.description
      },
      elementType: SensitivityTooltip,
      renderByDefault: true
    })
  };
};
//# sourceMappingURL=useSensitivityLabel.js.map